import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const firstVariant = product.variants?.[0];

  const handleAdd = (e) => {
    e.preventDefault();
    if (!firstVariant) return;
    addItem(product, firstVariant, 1);
  };

  return (
    <Link
      to={`/product/${product.handle}`}
      data-testid={`product-card-${product.handle}`}
      className="br-product-card group block"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-walnut/5">
        {product.images?.[0] && (
          <img
            src={product.images[0]}
            alt={product.title}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        )}
        {/* Hover Add to bag overlay */}
        <div className="br-add-overlay absolute inset-x-4 bottom-4">
          <button
            data-testid={`quick-add-${product.handle}`}
            onClick={handleAdd}
            className="w-full bg-cream/95 backdrop-blur-sm text-espresso text-[11px] uppercase tracking-[0.3em] py-3 hover:bg-espresso hover:text-cream transition-colors duration-500"
          >
            Add to bag
          </button>
        </div>
      </div>
      <div className="mt-5 px-1">
        <h3 className="font-serif text-lg text-espresso leading-snug">{product.title}</h3>
        <div className="mt-1 text-sm font-light text-walnut">€{parseFloat(product.price).toFixed(2)}</div>
      </div>
    </Link>
  );
}
